import React from 'react';
import { Button, Card, CardBody, CardHeader, ListGroup, ListGroupItem } from 'reactstrap';

function n(v) { var x = parseFloat(v); return isFinite(x) ? x : 0; }
function money(v) { return n(v).toFixed(2); }

/**
 * totales (flexible):
 *  - detallePlanes: [{ nombre, cantidad_asegurados, subtotal_prima_neta, subtotal_prima_bruta }]
 *  - num_asegurados
 *  - resumenPlanesUI: { subtotal, impuestos, total }  // preferido
 *    ó subtotal_persona, impuestos_persona, total_persona
 *    ó total_por_asegurado (fallback para total_persona)
 *  - impuestos_listado | impuestos : [{ nombre, porcentaje, valor }]
 *  - total_general (opcional; si lo envía backend)
 */
const TotalesPoliza = ({ totales = {}, confirmacion, globales }) => {
  const primaNeta = n(globales.total_prima_neta);
  const sumaImpuestos = n(globales.impuestos_sum);
  const derechosEmision = n(totales.derechosEmision);
  const total_poliza = n(globales.total_poliza) || n(totales.totalPoliza);
  const total_prima_neta = n(totales.total_prima_neta) || n(totales.total_prima_neta);

  console.log("🚀 ~ TotalesPoliza ~ totales:", totales)
  // Planes
  var detallePlanes = Array.isArray(totales.detallePlanes) ? totales.detallePlanes : [];

  // Por persona
  var resumenUI = totales.resumenPlanesUI || totales.resumen_planes_ui || totales.resumen_persona || {};
  var subtotal_persona = n(totales.subtotalPersona) || n(resumenUI.subtotalPersona);
  var impuestos_persona = n(totales.impuestos_persona) || n(resumenUI.impuestos);
  var total_persona = n(totales.total_persona) || n(resumenUI.total) || n(totales.total_por_asegurado);

  // Impuestos (detalle)
  var impuestosListado = Array.isArray(totales.impuestos_listado)
    ? totales.impuestos_listado
    : (Array.isArray(totales.impuestos) ? totales.impuestos : []);
  

  // Globales
  var num_asegurados = n(totales.num_asegurados);
  var total_general = n(totales.total_general); // opcional

  return (
    <Card className="mb-4 shadow-sm border-0 rounded">
      <CardHeader><strong>Totales por Plan</strong></CardHeader>
      <CardBody>

        {/* === Planes (listado) === */}
        <h6 className="mb-2">Planes</h6>
        {detallePlanes.length === 0 ? (
          <div className="text-muted mb-3">Sin planes.</div>
        ) : (
          <ListGroup className="mb-3">
            {detallePlanes.map(function (plan, idx) {
              return (
                <ListGroupItem key={idx}>
                  <div className="fw-bold">{plan.nombre}</div>
                  <div className="small text-muted mb-1"># Asegurados: {plan.cantidad_asegurados}</div>
                  <ul className="mb-0">
                    <li>Prima Neta: <strong>${money(plan.subtotal_prima_neta)}</strong></li>
                    <li>Prima Total (Bruta): <strong>${money(plan.subtotal_prima_bruta)}</strong></li>
                  </ul>
                </ListGroupItem>
              );
            })}
          </ListGroup>
        )}

        {/* === Resumen por persona (con detalle de impuestos aquí mismo) === */}
        <h6 className="mb-2">Resumen por persona</h6>
        <ListGroup className="mb-4">
          <ListGroupItem className="d-flex justify-content-between">
            <span>Prima Neta</span>
            <strong>${money(primaNeta)}</strong>
          </ListGroupItem>

          <ListGroupItem>
            <div className="d-flex justify-content-between">
              <span>Impuestos 4% </span>
              <strong>${money(sumaImpuestos)}</strong>
            </div>

            {impuestosListado.length > 0 && (
              <ul className="mt-2 mb-1 small">
                {impuestosListado.map(function (imp, j) {
                  return (
                    <li key={'imp-' + j} className="d-flex justify-content-between">
                      <span>{imp.nombre}</span>
                      <span>${money(imp.valor)}</span>
                    </li>
                  );
                })}
                {/* <li className="d-flex justify-content-between fw-semibold">
                  <span>Subtotal impuestos</span>
                  <span>${money(sumaImpuestos)}</span>
                </li> */}
              </ul>
            )}

          </ListGroupItem>
          <ListGroupItem className="d-flex justify-content-between">
            <span>Derechos de emisión</span>
            <strong>${money(derechosEmision)}</strong>
          </ListGroupItem>
          {/* <ListGroupItem className="d-flex justify-content-between">
            <span>Prima total</span>
            <strong>${money(total_prima_neta)}</strong>
          </ListGroupItem> */}
        </ListGroup>

        {/* === Total de la póliza === */}
        <ListGroup className="mb-4">
          <ListGroupItem className="d-flex justify-content-between bg-light">
            <span>
              Total =
            </span>
            <strong>${money(total_poliza)}</strong>

          </ListGroupItem>
          <div className="small text-muted mb-1">  ({num_asegurados} asegurado{num_asegurados === 1 ? '' : 's'}) × (prima total)</div>


        </ListGroup>

        <div className="text-center">
          <Button
            onClick={confirmacion}
            style={{ backgroundColor: "#001871", color: "white", border: "none", width: "60%" }}
          >
            CONFIRMAR
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default TotalesPoliza;
